import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import pinyin from './pinyin';
export default {
    props: {
        options: {
            type: Array,
            default: ()=>[]
        },
        filter: {
            type: Array,
            default: ()=>[]
        }
    },
    data () {
        return {
            optionsList: [],
            optionsList_: []
        };
    },
    mounted () {
        this.optionsList = this.options;
        this.optionsList_ = [
            ...this.options
        ];
    },
    methods: {
        filterMethod (keyword) {
            if (keyword) {
                this.optionsList = this.optionsList_;
                this.optionsList = this.optionsList.filter((item)=>pinyin.match(item.label, keyword));
            } else {
                this.optionsList = this.optionsList_;
            }
        },
        visibleChange (isopen) {
            if (isopen) {
                this.optionsList = this.optionsList_;
            }
        },
        isDisabled (key) {
            if (this.filter.find((item)=>item.field.value == key && !item.field.repeat)) {
                return true;
            } else {
                return false;
            }
        }
    }
};
